import React from 'react';
import styled from 'styled-components';

import { SocialShareLinks } from '@components';

const Wrapper = styled.div`
  text-align: center;
  padding: 20px;
  margin-bottom: 20px;
`;

const Title = styled.p`
  font-size: 14px;
  font-weight: 600;
  padding: 20px 0;
`;

const ShareSection = ({ url, title, description, isColumn }) => (
  <Wrapper>
    <Title>FOUND THIS USEFUL? SHARE WITH</Title>
    <SocialShareLinks shareUrl={url} title={title} description={description} isColumn={isColumn} />
  </Wrapper>
);

export default ShareSection;
